import styled from "styled-components";

export const Wrapper = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  svg {
    path {
      stroke: ${({ theme }) => theme.message.color};
    }
  }
`;
export const Text = styled.span``;
export const Container = styled.div`
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: ${({ theme }) => theme.message.color};
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.message.color};
  text-decoration: underline;
  margin: 0 5px;
  font-size: 14px;
  line-height: 24px;

  &:hover {
    text-decoration: none;
  }
`;
